import { Box, TextV2 } from '@withjoy/joykit';
import { styled, pxToRem } from '@withjoy/joykit/theme';

export const ADMIN_HEADER_HEIGHT_MOBILE = 64;
export const ADMIN_HEADER_HEIGHT_DESKTOP = 80;
export const MOBILE_NAV_ROW_HEIGHT = 48;

/**
 * Shared header height constant used by both Root and Spacer components.
 * Ensures spacer height stays in sync with header height.
 */
export const HEADER_HEIGHT = {
  base: pxToRem(ADMIN_HEADER_HEIGHT_MOBILE),
  md: pxToRem(ADMIN_HEADER_HEIGHT_DESKTOP),
} as const;

export const HEADER_HEIGHT_FIXED = pxToRem(80);

export const StyledRoot = styled(Box)`
  flex-shrink: 0;
  @media print {
    display: none;
  }
`;

export const StyledLeftSection = styled(Box)``;

export const StyledRightSection = styled(Box)``;

export const StyledTitle = styled(TextV2)``;
